import { render } from "./Avatar.vue?vue&type=template&id=9bdb9e64&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=9bdb9e64&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9bdb9e64"

export default script